import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { IngredientLineWrite } from "./useCreateIngredientLine";

type UpdateIngredientLine = {
    ingredientLineId: number;
    ingredientLine: IngredientLineWrite;
};

export const useUpdateIngredientLine = () => {
    const queryClient = useQueryClient();
    const query = useMutation({
        mutationFn: async (options: UpdateIngredientLine) => {
            const { ingredientLineId, ingredientLine } = options;
            const response = await loggedInApiCall.put(`/api/ingredient_lines/${ingredientLineId}`, ingredientLine);
            return response;
        },
        onSuccess: () => {
            queryClient.invalidateQueries(["allIngredientLines"]);
        },
    });

    return query;
};
